<template>
    <div class="frame">
        <div class="top-frame flex-wrap">
            <div v-if="!$route.path.includes('licente')" class="item-a">
                <p class="companyName">{{ companieSelectata ? companieSelectata.name : '' }}</p>
                <p v-if="caen" class="gray">Maximum nerambursabil: <span class="green"><strong>{{ maxBudget ? maxBudget.toLocaleString('ro-RO') : 0 }}€</strong></span></p>
                <p v-if="status" class="gray">Statut TVA: <span class="white">{{ status }}</span></p>
            </div>
            <span v-if="!$route.path.includes('licente')" class="dotted-border"></span>
            <div class="item-top item-b">
                <p class="max-width">Timp rămas concepere proiecte</p>
<!--                <p class="counter" :class="calculateDepunereTimer().days <= 5 ? 'red blinker' : ''">
                    {{ calculateDepunereTimer().days }} <span class="gray">zile</span>&nbsp;
                    {{ calculateDepunereTimer().hours }} <span class="gray">ore</span>&nbsp;
                    {{ calculateDepunereTimer().minutes }} <span class="gray">minute</span>
                </p>
				<p>Depunere: <span class="green">21 - 25 martie 2022</span></p>-->
                <p class="warn-text" @click="showM3Amanare = true">
                    <img src="@/assets/images/warn-sign-big.png" style="max-width: 30px; margin-right: 10px; height: auto; align-self: flex-start;">
                    NECUNOSCUT
                </p>
<!--                <p v-else class="deschis max-width ">Deschis</p>-->
<!--                <p class="counter">Necunoscut</p>-->
            </div>
            <span class="dotted-border"></span>
            <div class="item-top flex item-c">
                <div v-show="companies">
                    <div v-if="!currentCompanyPaid">
                        <p class="max-width">Timp rămas licență gratuită</p>
                        <p v-if="timpRamasLicentaGratuita && (timpRamasLicentaGratuita.days > 0 || timpRamasLicentaGratuita.hours > 0 || timpRamasLicentaGratuita.minutes > 0)" class="counter" :class="timpRamasLicentaGratuita.days < 5 ? 'red' : ''">
                            {{ timpRamasLicentaGratuita.days }} <span class="gray">zile</span>&nbsp;
                            {{ timpRamasLicentaGratuita.hours }} <span class="gray">ore</span>&nbsp;
                            {{ timpRamasLicentaGratuita.minutes }} <span class="gray">minute</span>
                            <router-link to="/aplicatii/m3-sketch/licente" class="expireTrial">
                                Atenție, Trial-ul expiră curând
                            </router-link>
                        </p>
                        <div v-else>
                            <p class="inchis max-width">Trial expirat</p>
                            <router-link class="expireTrial" to="/aplicatii/m3-sketch/licente">Cumpără licență</router-link>
                        </div>
                        <!--                        <p class="counter">Necunoscut</p>-->
                    </div>
                    <div v-else>
                        <router-link class="companyPaid" to="/aplicatii/m3-sketch/licente">Licență achiziționată</router-link>
                    </div>
                    <!--                    <p class="counter">Necunoscut</p>-->
                </div>
            </div>
            <div v-if="!$route.path.includes('licente')" class="flex align-center punctaj">
                <div class="chart x-20" :style="'--value:'+ getTotalScore + '%; background-image: conic-gradient('+ getChartColor +' var(--value), lightgrey var(--value)) !important;'">
                    <p>{{ getTotalScore ? getTotalScore : 0 }}</p>
                </div>
                <p class="bold"><span class="green">Smis<sup>®</sup></span> Punctajul proiectului tău</p>
            </div>
            <div v-if="!$route.path.includes('licente')" class="flex align-items-end punctaj">
                <div class="chart x-20" style="margin-right: 2px;" :style="'--value:'+ calculateEnvironmentPercentage + '%; background-image: conic-gradient(#49cda8 var(--value), lightgrey var(--value)) !important;'">
                    <p>{{ calculateEnvironmentPercentage }}%</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/procentMediu.png" alt="Procent de mediu" title="Contribuția cheltuielii la obiectivele de mediu" style="width: 17px; height: 20px">
            </div>
            <span class="dotted-border"></span>
            <div class="item-top item-d flex flex-column space-between top-frame-btns-wrapper">
                <router-link class="button-red" to="/aplicatii/m3-status">
                    Adaugă companie
                </router-link>
                <div class="button-green" style="cursor: pointer;" @click="modalShow = true">
                    Schimbă compania
                </div>
                <SchimbaCompaniaPopup
                    :schimbaModal="modalShow"
                    :companii="companies"
                    :companie-selectata="companieSelectata"
                    @hideTempModal="modalShow = false"
                    @changeCompany="changeCompany($event)"
                ></SchimbaCompaniaPopup>
                <M3AmanarePopup :showPopup="showM3Amanare" @hideTempModal="showM3Amanare = false"></M3AmanarePopup>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import SchimbaCompaniaPopup from './SchimbaCompaniaPopup'
    import M3AmanarePopup from './M3AmanarePopup'
    import _ from "lodash";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    export default {
        components: {
            vSelect,
            SchimbaCompaniaPopup,
            M3AmanarePopup
        },

        props: {
            unsavedChanges: null,
            currentCompanyPaid: null,
        },

        data() {
            return {
                companii: [],
                // dataDeschidereMySmis:new Date('oct 26, 2021 00:00:00'),
                dataInchidereDepuneri: {},
                timpRamasMySmis:{},
                timpRamasLicentaGratuita:{},
                modalShow: false,
                totalScore: 0,
                showModal: false,
                next: null,
                today: new Date(),
                environmentPercentage: 0,
                showM3Amanare: false
            }
        },
        computed: {
            getTotalScore() {
                return !this.statistics ? 0 : this.statistics.scadere_ca + this.statistics.produs_inovativ + this.statistics.cresterea_productivitatii + this.statistics.caen_negativ + this.statistics.investitii_mediu
            },
            getChartColor() {
                if(this.getTotalScore < 70){
                    return '#ea8196'
                } else {
                    return '#49cda8'
                }
            },
            calculateEnvironmentPercentage() {
                if(this.statistics && this.statistics.environment_percentage) {
                    return this.statistics.environment_percentage.toFixed(0)
                }
                return 0
            },
            allData() {
                return this.$store.getters['m3Sketch/allData'];
            },
            statistics() {
                return this.$store.getters['m3Sketch/indicators'];
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            status() {
                return this.allData ? this.allData.vat_status : null;
            },
            turnover() {
                return this.allData ? this.allData.turnover : null;
            },
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
            caen() {
                return this.allData && this.allData.m3_project ? this.allData.m3_project.caen : null
            },
            companieSelectata() {
                return this.$store.getters['m3Sketch/m3Company'];
            }
        },

        created() {
            axios.get(api.API_ENDPOINTS.m3Licenses)
                .then( response => {
                    this.today = new Date(response.data.today);
                    this.timpRamasLicentaGratuita = this.calculateTimer();
                    setInterval(()=>{
                        this.timpRamasLicentaGratuita = this.calculateTimer();
                    }, 20000)
                })
        },
        mounted() {
            axios.get(api.API_ENDPOINTS.m3Licenses)
                .then( response => {
                    this.today = new Date(response.data.today);
                    this.timpRamasLicentaGratuita = this.calculateTimer();

                })
        },

        methods: {
            changeCompany(event) {
                localStorage.setItem('currentM3Company', JSON.stringify(event))
                location.reload();
            },

            calculateTimer() {
                let currentTime = this.today;
                if(JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).business_id) {
                    let currentCompany = _.filter(this.companies, v => Number(v.business_id) === Number(JSON.parse(localStorage.getItem('currentM3Company')).business_id))
                    if(currentCompany && currentCompany[0]) {
                        let expire = new Date(currentCompany[0].created);
                        if(expire < new Date('02-21-2022')) {
                            expire = new Date('02-28-2022')
                        } else {
                            expire.setDate(expire.getDate() + 5);
                        }

                        if(expire <  new Date('02-28-2022'))
                            expire =  new Date('02-28-2022')

                        let distance = expire - currentTime;
                        let timer = {
                            days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                            hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                            seconds: Math.floor((distance % (1000 * 60)) / 1000),
                        }
                        return timer;
                    }
                }
            },
			calculateDepunereTimer() {
				let currentTime = this.today;

				let expire = new Date('2022-03-25T23:59:00');

				let distance = expire - currentTime;
				let timer = {
					days: Math.floor(distance / (1000 * 60 * 60 * 24)),
					hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
					minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
					seconds: Math.floor((distance % (1000 * 60)) / 1000),
				}
				return timer;
			}
        }
    }
</script>

<style scoped>
/*.item-a{*/
/*width: 23%;*/
/*}*/
/*.item-b{*/
/*width: 23%;*/
/*}*/
/*.item-c{*/
/*width: 40%;*/
/*}*/
.warn-text{
    color: #ffdf40;
    font-weight: 600;
    font-size: 15px;
    margin-top: 7px;
    cursor: pointer;
}
.warn-text img{
    animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
.item-d{
    /*width: 14%;*/
    align-items: center;
}
.top-frame{
    background: linear-gradient(to bottom, #8c6984, #816e8b);
    width: 100%;
    padding: 5px 20px;
    max-height: 100px;
    position: relative;
}
.top-frame > div:not(.item-d){
    padding: 15px 0;
}
.frame{
    position: relative;
    box-shadow: -4px 9px 10px -9px black;
}
.flex-column{
    flex-direction: column;
}
.flex-wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0 10px;
}
p{
    margin: 0;
    color: #fff;
}
.firma p{
    font-size: 14px;
}
.gray{
    color: #af9fb0;
    font-size: 15px;
}
.white{
    color: #fff;
}
.counter{
    font-size: 21px !important;
    color: #cfc3cf;
    text-align: left;
}
.counter.red, .counter.red .gray{
    color: #eb8a9d;
}
.flex{
    display: flex;
}
.item-a p{
    font-size: 14px;
}
.space-between{
    justify-content: space-between;
}
.align-center{
    align-items: center;
}
.green{
    color: #48cda7;
}
.bold{
    font-weight: 500;
}
.punctaj p{
    max-width: 105px;
    text-align: left;
}
.button-red, .button-white, .button-green{
    width: 100%;
    max-width: 180px;
    color: #fff;
    font-size: 12px;
    padding: 3px 15px;
    cursor: pointer;
    transition: 0.3s;
    border-radius: 4px;
    text-align: center;
}
.changeCompany {
    max-width: 190px;
}
.expireTrial{
    color: #545a6f;
    display: block;
    font-size: 12px;
    background: #ffe400;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
    animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
.blinker{
	animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
.companyPaid{
    padding: 3px 10px;
    color: #fff;
    display: block;
    font-size: 12px;
    background: #49cda8;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
}
.companyPaid:hover{
    background: #3cb492;
    text-decoration: none;
}
.expireTrial:hover{
    background: #ca7183;
    text-decoration: none;
}
.button-red{
    background: #ea8196;
    border: 1px solid #ea8196;
    margin-bottom: 5px;
    transition: 0.3s;
}
.button-red:hover{
    background: #ca7183;
    border: 1px solid #ca7183;
    text-decoration: none;
}
.button-green{
    background: #49cda8;
    border: 1px solid #49cda8;
    margin-bottom: 5px;
}
.button-green:hover{
    background: #36987d;
    border: 1px solid #36987d;
    transition: 0.3s;
}
.button-white{
    background: transparent;
    border: 1px solid #fff;
}
.button-white:hover{
    background: #fff;
    border: 1px solid #fff;
    color: #ea8196;
    transition: 0.3s;
}
.top-frame .item-top{
    position: relative;
}
.dotted-border{
    border-right: 2px dotted #fff;
    display: block;
    min-height: 60px;
    width: 2px;
    height: 100%;
    opacity: 0.3;

}
.deschis{
    color: #48cda7;;
    font-weight: bold;
    font-size: 14px;
}
.inchis{

    color: #ffe400;;
    font-weight: bold;
    font-size: 14px;
}
.visibility-none{
    visibility: hidden;
}
@media(max-width: 1700px) {
    .counter {
        font-size: 18px !important;
    }
    .item-a p {
        font-size: 12px;
    }
    .gray{
        font-size: 12px;
    }
    .top-frame > div:not(.item-d){
        padding: 10px 0;
    }
}
@media(max-width: 1350px) {
    .punctaj{
        flex-direction: column;
    }
    .punctaj p.bold{
        font-size: 10px;
        text-align: center;
    }
    .top-frame {
        padding: 5px 20px;
        max-height: inherit;
    }
    .top-frame > div:not(.item-d){
        padding: 0;
    }
    .top-frame-btns-wrapper {
        flex-direction: row!important;
        width: 40%;
    }
}
@media screen and (max-width: 1180px) {

    .top-frame-btns-wrapper .button-red,
    .top-frame-btns-wrapper .button-green {
        min-width: 160px;
    }
    .top-frame-btns-wrapper .button-red {
        margin-right: 10px;
    }
}
</style>
